import { FormEvent } from "react";
import { YesNoUnknown } from "@nkr/enums/yes-no-unknown";

interface IProps {
    name        : string,
    value       : YesNoUnknown | null,
    onChange    : (name: string, value: YesNoUnknown) => void
}

const YesNoUnknownRadio = (props: IProps) => {
    const handleClick = (e: FormEvent<HTMLInputElement>) => {
        props.onChange(e.currentTarget.name, parseInt(e.currentTarget.value));
    };

    return (
        <div className='yes-no-unknown'>
            <label className='radio-inline' style={{paddingTop: 0}}>
                <input id={props.name + '_Yes'} name={props.name} type='radio' checked={props.value == YesNoUnknown.Yes} value={YesNoUnknown.Yes} onClick={handleClick} /> Yes
            </label>
            <label className='radio-inline' style={{paddingTop: 0}}>
                <input id={props.name + '_No'} name={props.name} type='radio' checked={props.value == YesNoUnknown.No} value={YesNoUnknown.No} onClick={handleClick} /> No
            </label>
            <label className='radio-inline' style={{paddingTop: 0}}>
                <input id={props.name + '_Unknown'} name={props.name} type='radio' checked={props.value == YesNoUnknown.Unknown} value={YesNoUnknown.Unknown} onClick={handleClick} /> Unknown
            </label>
        </div>
    );
}

export { YesNoUnknown };
    
export default YesNoUnknownRadio;